var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theo-player-component" }, [
    _vm.playable
      ? _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.canDisplay,
              expression: "canDisplay"
            }
          ],
          ref: "theoplayer",
          staticClass: "theoplayer-container video-js theoplayer-skin vjs-16-9",
          class: [{ "sources-unavailable": _vm.isUnavailable }]
        })
      : _c("div", { staticClass: "theo-unable" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$browser.name) +
              " play will be available soon. Please use Safari to play this content.\n    "
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }